export { InviteAsFriendFeature } from './invite-as-friend';
